const PREFIX = "error-widget";

export const ERROR_WIDGET_TEST_IDS = {
    CONTAINER: `${PREFIX}-container`,
    TITLE: `${PREFIX}-title`,
    MESSAGE: `${PREFIX}-message`,
    CTA_BUTTON: `${PREFIX}-cta-button`,
    CTA_BUTTON_SECONDARY: `${PREFIX}-cta-button-secondary`,
    ITEMS_LIST: `${PREFIX}-items-list`,
    ITEM: `${PREFIX}-item`,
    ITEMS_LIST_HEADER: `${PREFIX}-items-list-header`,
};
